<template>
  <div class="page flex-col">
    <div class="header flex-row">
      <BackButton
        :customClick="handleBackClick"
        class="back_button"
      />
    </div>

    <div class="menu flex-row">
      <TeacherMenu />
    </div>

    <div class="main_container flex-col">
      <span class="lesson_name">{{ lessonName }}</span>

      <div class="lists_container flex-col">
        <div
          v-for="(item, index) in resources"
          :key="index"
          class="resource_item flex-col group"
        >
          <div class="flex-row justify-between">
            <div class="flex-row justify-start">
              <img
                class="resource_icon"
                referrerpolicy="no-referrer"
                :src="getImg(item.resource_type)"
              />
              <div class="item_name">{{ item.resource_name }}</div>
              <img
                v-if="
                  item.resource_type == 'video' ||
                  item.resource_type == 'web' ||
                  item.resource_type == 'png'
                "
                class="video_play_icon"
                referrerpolicy="no-referrer"
                src="../../assets/teacher/resources/FigmaDDSSlicePNGd029879c92d0af12eb5ee5143c32669a.png"
                @click="clickResource(item.url, item.resource_type)"
              />
            </div>
            <div class="action_buttons flex-row justify-end">
              <img
                v-if="item.resource_type != 'web'"
                class="download_icon"
                referrerpolicy="no-referrer"
                src="../../assets/teacher/resources/FigmaDDSSlicePNG804623974d40fe4b0c258571423f1782.png"
                @click="downloadZip(item.url, item.resource_name)"
              />
              <img
                v-if="item.priority != 0"
                class="delete_icon"
                referrerpolicy="no-referrer"
                src="../../assets/teacher/resources/FigmaDDSSlicePNG36e6ff331c68017a3dcf28e8fc467142.png"
                @click="deleteResource(item)"
              />
            </div>
          </div>
          <div class="item_separator flex-col"></div>
        </div>
      </div>

      <div class="upload_section flex-row justify-end">
        <div
          class="upload_container flex-row"
          @click="handleUploadClick"
        >
          <input
            type="file"
            ref="fileInput"
            style="display: none"
            @change="handleFileChange"
          />
          <div class="upload_button flex-row justify-between">
            <img
              class="upload_image"
              referrerpolicy="no-referrer"
              src="../../assets/teacher/resources/FigmaDDSSlicePNG765f29b3456969bb90435342d13814ae.png"
            />
            <span class="upload_text">上传</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useRoute, useRouter } from "vue-router"
import { useStore } from "vuex"

import BackButton from "@/components/teacher/BackButton.vue"
import TeacherMenu from "@/components/teacher/TeacherMenu.vue"
import alovaInstance from "@/utils/alova"

const route = useRoute()
const store = useStore()
const router = useRouter()
const lessonName = ref("")
// const resources = ref([
//   {
//     resource_type: "video",
//     resource_name: "视频1",
//     priority: "0",//0系統，1用戶
//     url: "https://www.bilibili.com/video/BV17F4y1h784/",
//   },
// ])
const resources = ref([])

onMounted(async () => {
  lessonName.value = store.getters.getLessonName
  try {
    let lessonId = route.query.lessonId
    // console.log(lessonId)
    const response = await alovaInstance.Post("/Record/GetTeacherResource", {
      lessonId: lessonId,
    })
    // console.log(response)
    if (response.code === 1000) {
      resources.value = response.data
    } else {
      alert("获取数据失败：" + response.message)
    }
  } catch (error) {
    console.error("获取数据失败:", error)
    alert("获取数据失败，请稍后重试")
  }
})

const getImg = (type) => {
  if (type == "video") {
    return require("@/assets/teacher/resources/FigmaDDSSlicePNG1877755e2db6cdae6dec4435b87cef5a.png")
  } else if (type == "ppt") {
    return require("@/assets/teacher/resources/FigmaDDSSlicePNG0d5d998938046252c2c2073a207e579b.png")
  } else if (type == "zip") {
    return require("@/assets/teacher/resources/FigmaDDSSlicePNGf370d02fa7c5e92619f491d19c61fccd.png")
  } else if (type == "hex") {
    return require("@/assets/teacher/resources/FigmaDDSSlicePNG36e6ff331c68c2c200c258fe4b0c2585.png")
  } else if (type == "png") {
    return require("@/assets/teacher/resources/FigmaDDSSlicePNG125e61a940cdd59bd88f9ec1f78c5ef6.png")
  } else if (type == "web") {
    return require("@/assets/teacher/resources/FigmaDDSSlicePNG34ed7ee9658cef0c88d652ac1f693cad.png")
  } else {
    return require("@/assets/teacher/resources/FigmaDDSSlicePNG34ed7ee9658cef0c88d652ac1f693cad.png")
  }
}

const downloadZip = (url, name) => {
  const link = document.createElement("a")
  link.href = url
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const deleteResource = async (item) => {
  if (!confirm('确定要删除该资源吗？')) {
    return
  }

  try {
    const response = await alovaInstance.Post("/Record/DeleteCustomResource", {
      resourceId: item.id
    })
    if (response.code === 1000) {
      resources.value.splice(resources.value.indexOf(item), 1)
    } else {
      alert("删除失败：" + response.message)
    }
  } catch (error) {
    console.error("删除失败:", error)
    alert("删除失败，请稍后重试")
  }
}

const fileInput = ref(null)
const uploading = ref(false)

const handleUploadClick = async () => {
  if (uploading.value) {
    alert("正在上传中，请稍候...")
    return
  }
  // 触发文件选择
  fileInput.value.click()
}

const ossUploadParams = ref(null)

// 获取STS token的辅助函数
const getOssToken = async () => {
  const lessonId = route.query.lessonId
  const response = await alovaInstance.Post("/Record/GetTeacherResourceStsToken", {
    lessonId: lessonId
  })
  if (response.code !== 1000) {
    throw new Error(response.message || "获取上传参数失败")
  }
  return response.data
}

const handleFileChange = async (event) => {
  const file = event.target.files[0]
  if (!file) {
    return
  }

  uploading.value = true

  try {
    // 先获取STS token（每次上传都获取新的，确保有效）
    const ossData = await getOssToken()
    ossUploadParams.value = ossData

    // 3. 上传文件到阿里云OSS
    const formData = new FormData()

    // 添加OSS需要的参数（根据实际返回字段调整）
    if (ossData.policy) formData.append('policy', ossData.policy)
    if (ossData.signature) formData.append('signature', ossData.signature)
    if (ossData.accessKeyId) formData.append('OSSAccessKeyId', ossData.accessKeyId)
    if (ossData.accessKeyId) formData.append("x-oss-security-token", ossData.securityToken)
    formData.append("success_action_status", "200")
    const key = `${ossData.directory}${file.name}`
    formData.append('key', key)
    
    if (ossData.callback) formData.append('callback', ossData.callback)

    // 添加文件
    formData.append('file', file)

    // 上传到OSS
    const uploadResponse = await fetch(ossData.host, {
      method: 'POST',
      body: formData
    })

    if (!uploadResponse.ok) {
      throw new Error('OSS上传失败')
    }

    // 拼接url
    const fileUrl = ossData.host + "/" + key

    // 4. 调用Record/UploadTeacherResource上传url和LessonId
    const lessonId = route.query.lessonId
    const customResourceResponse = await alovaInstance.Post("/Record/UploadTeacherResource", {
      lessonId: lessonId,
      url: fileUrl
    })

    if (customResourceResponse.code === 1000) {
      // 上传成功，刷新资源列表
      await refreshResources()
      alert("上传成功")
    } else {
      alert("保存资源信息失败：" + customResourceResponse.message)
    }
  } catch (error) {
    console.error("上传失败:", error)
    alert("上传失败，请稍后重试")
  } finally {
    uploading.value = false
    // 清空file input，允许重复上传同一文件
    event.target.value = ''
    ossUploadParams.value = null
  }
}

const refreshResources = async () => {
  try {
    const lessonId = route.query.lessonId
    const response = await alovaInstance.Post("/Record/GetTeacherResource", {
      lessonId: lessonId,
    })
    if (response.code === 1000) {
      resources.value = response.data
    }
  } catch (error) {
    console.error("刷新资源列表失败:", error)
  }
}

const clickResource = (url, type) => {
  // 如果是图片类型，使用图片预览方式
  if (type === "png") {
    try {
      // 方法1: 创建图片预览窗口（更优雅的显示）
      const newWindow = window.open("", "_blank")
      if (newWindow) {
        newWindow.document.write(
          "<!DOCTYPE html>" +
            "<html>" +
            "<head>" +
            '<meta charset="utf-8">' +
            '<meta name="viewport" content="width=device-width, initial-scale=1">' +
            "<title>图片预览</title>" +
            "<style>" +
            "* { box-sizing: border-box; }" +
            "body { margin: 0; padding: 20px; display: flex; justify-content: center; align-items: center; min-height: 100vh; background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }" +
            ".image-container { text-align: center; background: white; padding: 20px; border-radius: 10px; box-shadow: 0 10px 30px rgba(0,0,0,0.1); }" +
            "img { max-width: 90vw; max-height: 90vh; border-radius: 8px; cursor: zoom-in; transition: transform 0.3s ease; }" +
            "img:hover { transform: scale(1.02); }" +
            "</style>" +
            "</head>" +
            "<body>" +
            '<div class="image-container">' +
            '<img id="previewImage" src="' +
            url +
            '" alt="图片" />' +
            "</div>" +
            "</body>" +
            "</html>"
        )
        newWindow.document.close()
      }
    } catch (error) {
      // 如果弹窗被阻止，使用备用方案
      console.warn("弹窗被阻止，使用备用方案")
      // 方法2: 使用a标签方式（更兼容）
      const link = document.createElement("a")
      link.href = url
      link.target = "_blank"
      link.rel = "noopener noreferrer"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  } else {
    // 其他类型保持原有行为
    window.open(url, "_blank")
  }
}

const handleBackClick = () => {
  router.push({
    name: "TeacherCourse",
    query: {
      courseName: store.state.courseName,
      courseId: store.state.courseId,
    },
  })
}
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  position: relative;
  width: 100%;
  height: auto;
  background-color: rgba(234, 238, 242, 1);
  overflow: hidden;
}

.header {
  width: 80.6771vw;
  height: 3.4375vw;
  margin: 0.8854vw 0 0 1.5vw;
}

.back_button {
  margin-right: 1.5vw;
}

.menu {
  width: auto;
  height: auto;
  margin: 0 0 0 1.5vw;
}

.main_container {
  position: relative;
  width: 100vw;
  height: auto;
  min-height: 30vw;
  margin-left: 1.5vw;
  overflow: hidden;
}

.lesson_name {
  width: 30vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 1.25vw;
  margin: 1.3vw 0 1vw 0;
}

.lists_container {
  width: 81vw;
  height: 27.7vw;
  background: #fff;
  border-radius: 0.83rem 0.83rem 0.83rem 0.83rem;
  overflow-y: auto;
  padding-top: 1.72vw;
}

.resource_item {
  width: 76.88vw;
  height: 2.5vw;
  margin: 0 0 0 1.72vw;
}

.resource_item:hover {
  background: #e9f4ff;
}

.upload_section {
  position: relative;
  width: 81vw;
  height: auto;
  margin-top: 1.41vw;
}

.upload_container {
  background-color: rgba(55, 91, 165, 1);
  border-radius: 4px;
  width: 10.32vw;
  height: 2.71vw;
  cursor: pointer;
}

.upload_button {
  width: 3.44vw;
  height: 1.1vw;
  margin: 0.78vw 0 0 3.43vw;
}

.upload_image {
  width: 1.05vw;
  height: 1.05vw;
  margin-top: 0.06vw;
}

.upload_text {
  width: 2.09vw;
  height: 1.05vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.resource_icon {
  width: 1.67vw;
  height: 1.67vw;
  margin: 0.41vw 0 0 1.14vw;
}

.item_name {
  width: auto;
  height: 2.4vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei UI-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 2.4vw;
  margin: 0 0 0 1vw;
  padding: 0;
}

.video_play_icon {
  width: 1.67vw;
  height: 1.67vw;
  margin: 0.41vw 0 0 0.93vw;
  cursor: pointer;
}

.download_icon {
  width: 1.67vw;
  height: 1.67vw;
  margin: 0.41vw 0.7vw 0 0;
  cursor: pointer;
}

.delete_icon {
  width: 1.67vw;
  height: 1.67vw;
  margin: 0.41vw 1.2vw 0 0;
  cursor: pointer;
}

.item_separator {
  background-color: rgba(217, 217, 217, 1);
  width: 76.88vw;
  height: 0.11vw;
}

.action_buttons {
  display: none;
}

.resource_item:hover .action_buttons {
  display: block;
}
</style>
